import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import Moment from 'moment';
import User from "_class/User";
import * as microsoftTeams from "@microsoft/teams-js";
import { getSectionByGraphId } from "actions/sections";
import { setPageTitle, setPageActions } from 'actions/header';
import { getWithExpiration, saveWithExpiration } from 'helpers/localstorage';
import ScheduleView from 'containers/Schedule/ScheduleView';
import Modal from 'containers/Modals/Modal';
import SectionForm from 'containers/Forms/SectionForm';
import CalendarEventForm from 'containers/Forms/CalendarEvent';
import SectionTitle from 'components/Presentation/SectionTitle';
import { Button, Icon } from '@haldor/ui';

var AttendanceTabSection = /*#__PURE__*/function (_Component) {
  _inherits(AttendanceTabSection, _Component);

  var _super = _createSuper(AttendanceTabSection);

  function AttendanceTabSection(props) {
    var _this;

    _classCallCheck(this, AttendanceTabSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.currentUser);

      if (user.isTeacher()) {
        var actions = [];
        actions.push({
          type: 'icon',
          onClick: _this.toggleGroupSettings,
          icon: 'cog_bw'
        });
        actions.push({
          type: 'button',
          value: _this.props.translate('Create'),
          onClick: _this.toggleForm,
          icon: 'plus'
        });

        _this.props.setPageActions(actions);
      }

      _this.props.setPageTitle(_this.props.translate('attendance'));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroupSettings", function (shouldReload) {
      _this.setState({
        groupForm: !_this.state.groupForm
      });

      if (shouldReload == true) {
        microsoftTeams.app.getContext().then(function (context) {
          _this.props.getSectionByGraphId(context.team.groupId);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleForm", function () {
      _this.setState({
        createEvent: !_this.state.createEvent
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (date) {
      _this.setState({
        date: Moment(date)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleIcon", function (flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? 'i-90' : 'a-90',
        style: {
          height: '12px',
          width: '15px',
          margin: 0
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState({
                date: Moment(_this.state.date).subtract(1, 'day')
              });

            case 2:
              saveWithExpiration('haldor-schedule-date', _this.state.date.format());

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "goForward", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.setState({
                date: Moment(_this.state.date).add(1, 'day')
              });

            case 2:
              saveWithExpiration('haldor-schedule-date', _this.state.date.format());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "goToday", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                date: Moment()
              });

            case 2:
              saveWithExpiration('haldor-schedule-date', _this.state.date.format());

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    var _date = Moment();

    if (getWithExpiration('haldor-schedule-date') != null) {
      _date = Moment(getWithExpiration('haldor-schedule-date'));
    }

    _this.state = {
      date: _date,
      createEvent: false,
      groupForm: false
    };
    return _this;
  }

  _createClass(AttendanceTabSection, [{
    key: "render",
    value: function render() {
      var user = new User(this.props.currentUser);
      var isToday = Moment().isSame(this.state.date, this.state.type == 'week' ? 'week' : 'day');
      var studentId = null;

      if (user.isStudent()) {
        studentId = this.props.currentUser.id;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, this.props.group != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.groupForm,
        onClose: this.toggleGroupSettings,
        title: this.props.group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: this.toggleGroupSettings,
        editView: true,
        section: this.props.group
      })) : null, this.props.group != null && !user.isStudent() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createEvent,
        onClose: this.toggleForm,
        title: this.props.translate('create-lesson')
      }, /*#__PURE__*/React.createElement(CalendarEventForm, {
        onAbort: this.toggleForm,
        sectionId: this.props.group.id,
        onSubmit: this.onSubmit
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "container schedule"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("div", {
        className: "navigation-buttons-container"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0,
          marginRight: '0.5em'
        },
        onClick: this.goBack
      }, this.toggleIcon(false), "\xA0"), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: isToday,
        style: {
          marginRight: '0.5em',
          marginLeft: 0
        },
        onClick: this.goToday
      }, this.props.translate('today')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0
        },
        onClick: this.goForward
      }, this.toggleIcon(true), "\xA0"))), this.props.group != null ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          padding: 0,
          margin: 0,
          border: 0,
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement(ScheduleView, _extends({
        view: "day",
        date: this.state.date,
        userId: studentId
      }, this.props))) : null));
    }
  }]);

  return AttendanceTabSection;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    group: state.sections.graphSection
  };
}

export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getSectionByGraphId: getSectionByGraphId
})(AttendanceTabSection);